import { isErpApiSuccess } from "../erpClient";
import { extractListRowsFromResponse } from "./parseApiPagination";
import { aliasReverseDetail } from "./reverseGirviShape";

export {
  createGirviIdempotencyKey,
  isGirviApiSuccess,
  normalizeGirviBanksListResponse,
} from "./girviErpAdapter";

export {
  aliasReverseShowResponse,
  isReverseGirviClosed,
  mapReverseGirviSocketDetail,
  reverseGirviStatusLabel,
  suggestedMonthlyInterest,
  validateReversePayout,
} from "./reverseGirviShape";

export function normalizeListReverseGirvisRows(res) {
  if (!isErpApiSuccess(res)) return [];
  const arr = extractListRowsFromResponse(res, [
    "reverse_girvis",
    "girvis",
    "records",
  ]);

  return arr.map((row) => {
    const g = aliasReverseDetail(row);
    return {
      id: g.id ?? g.reverse_girvi_document_id ?? g.girvi_document_id ?? g.girvi_id,
      girvi_number: g.reverse_girvi_number || g.girvi_number || "",
      reverse_girvi_number: g.reverse_girvi_number || g.girvi_number || "",
      girvi_date: g.reverse_girvi_date || g.girvi_date || g.doc_date || "",
      reverse_girvi_date: g.reverse_girvi_date || g.girvi_date || "",
      due_date: g.due_date ?? null,
      customer_name: g.customer_name ?? g.supplier_name ?? "",
      customer_mobile: g.customer_mobile ?? g.mobile ?? g.supplier_mobile ?? "",
      principal_given: g.principal_taken ?? g.principal_amount ?? 0,
      principal_taken: g.principal_taken ?? g.principal_amount ?? 0,
      remaining_amount: g.remaining_amount ?? g.remaining_amt ?? 0,
      interest_percent: g.interest_percent ?? 0,
      monthly_interest: g.monthly_interest ?? 0,
      tenure_months: g.tenure_months ?? g.return_period ?? 0,
      status: g.status ?? "",
      raw: g,
    };
  });
}

export function getReverseGirviShowFirstObject(res) {
  if (!isErpApiSuccess(res)) return null;
  const data = res?.data;
  const first = Array.isArray(data) ? data[0] : data;
  if (!first || typeof first !== "object") return null;
  return first;
}
